import { FormFieldTypes } from "../../../../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../../../../components/forms/libs/data/ValidationTypes";
import { EditGridColumnType } from "../../../../../../components/molGrid/libs/data/editGridColumnType";

const initState = {
  originId: "",
  category: "",
  wordDocID: "",
  xmlReportId: ""
};

export const clientValuationDetailsDataFormConfig = {
  name: "Client Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Client Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "originId",
          label: "Origin",
          Field_Name: "origin",
          fieldType: FormFieldTypes.SELECT,
          dataField: "originId",
          fieldSetting: {
            placeholder: "Please select origin",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 col-12",
          },
        },
        {
          id: "category",
          label: "Category",
          Field_Name: "category",
          fieldType: FormFieldTypes.SELECT,
          dataField: "category",
          fieldSetting: {
            placeholder: "Please select category",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 col-12",
          },
        },
        {
          id: "wordDocID",
          label: "Document Name",
          Field_Name: "wordDocID",
          fieldType: FormFieldTypes.SELECT,
          dataField: "wordDocID",
          fieldSetting: {
            placeholder: "Please select document name",
            allowSpace: true,
            isDisable: false,
          },
          style: {
            containerCss: "col-lg-6 col-md-6 col-12",
          },
        },
        {
          id: "xmlReportId",
          label: "XML Report",
          Field_Name: "xmlReportId",
          fieldType: FormFieldTypes.SELECT,
          dataField: "xmlReportId",
          fieldSetting: {
            placeholder: "Please select xml report",
            allowSpace: true,
            isDisable: false,
            options: [],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 col-12",
          },
        },
      ],
    },
  ],
};

export const clientvaluationDetailDataGridConfig = {
  isRowSelectable: true,
  allowEdit: true,
  allowEditDoubleClick:true,
  hasChildGridTable: false,
  onRowDataUpdate: null,
  OnColumnChangeEdit: null,
  childGridSetting: {
    parentKeyDataField: "TLId",
    childKeyDataField: "TLId",
    hideChildHeader: true,
  },
  editSettings: {
    defualtEditableView: false,
    buttons: {
      save: true,
      cancel: true,
    },
  },
  columns: [
    {
      name: "Field Name",
      fieldName: "fieldName",
      colStyle: {
        textAlign: "left",
        width: "25%",
      },
      allowShort: true,
      allowEditColumn: false,
    },
    {
      name: "Merge Field Name",
      fieldName: "mergeFieldName",
      colStyle: {
        textAlign: "left",
        width: "22%",
      },
      allowShort: true,
      allowEditColumn: false,
    },
    {

      name: "Field Value",
      fieldName: "valFieldValue",
      colStyle: {
        textAlign: "left",
        width: "12%",
      },
      allowShort: false,
      allowEditColumn: true,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        editColFieldName: "valFieldValue",
        editColValidation: [],
      },
    },
    {
      name: "valfieldName",
      fieldName: "fieldName",
      colStyle: {
        textAlign: "left",
        width: "16%",
      },
      allowShort: true,
      allowEditColumn: false,
    },
    {
      name: "ValfieldValue",
      fieldName: "valFieldValue",
      colStyle: {
        textAlign: "left",
        width: "16%",
      },
      allowShort: false,
      allowEditColumn: true,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        editColFieldName: "valFieldValue",
        editColValidation: [],
      },
    },
    {
      name: "ValFieldMergeFieldName",
      fieldName: "valFieldMergeFieldName",
      colStyle: {
        textAlign: "left",
        width: "22%",
      },
      allowShort: false,
      allowEditColumn: false,
    },
    {
      name: "Copy Value",
      fieldName: "valFieldValue",
      colStyle: {
        textAlign: "left",
        width: "12%",
      },
      allowShort: false,
      allowEditColumn: true,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        editColFieldName: "copiedValue",
        editColValidation: [],
      },
    },
    {
      name: "Override Value",
      fieldName: "valFieldOverride",
      colStyle: {
        textAlign: "left",
        width: "19%",
      },
      allowShort: false,
      allowEditColumn: true,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        editColFieldName: "valFieldOverride",
        editColValidation: [],
      },
    },
    {
      name: "XML Override Value Field",
      fieldName: "xmlOverrideValueField",
      colStyle: {
        textAlign: "left",
        width: "16%",
      },
      allowShort: false,
      allowEditColumn: true,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        editColFieldName: "xmlOverrideValueField",
        editColValidation: [],
      },
    },

    {
      name: "ReportTemplateID",
      fieldName: "reportTemplateID",
      colStyle: {
        textAlign: "center",
        width: "22%",
      },
      allowShort: false,
      allowEditColumn: false
    },

    {
      name: "ReportTemplateFieldID",
      fieldName: "reportTemplateFieldID",
      colStyle: {
        textAlign: "center",
        width: "22%",
      },
      allowShort: false,
      allowEditColumn: false,
    },
    {
      name: "ValfieldId",
      fieldName: "valFieldID_I",
      colStyle: {
        textAlign: "center",
        width: "16%",
      },
      allowShort: false,
      allowEditColumn: false,
    },
  ],
};
